import { useEffect, useState } from 'react';

const navItems = [
  { label: '회사소개', href: '#about' },
  { label: '사업영역', href: '#business' },
  { label: '경쟁력', href: '#competitive' },
  { label: '베트남협력', href: '#vietnam' },
  { label: '비전', href: '#vision' },
  { label: '문의접수', href: '#inquiry' },
  { label: '연락처', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="flex items-center gap-2"
          >
            <img
              src="https://storage.readdy-site.link/project_files/0a155c0b-5c7a-49b7-acc8-8ff5e038e9e9/3f3dad74-7308-46d7-8d0e-529180c03494_KakaoTalk_20260505_183028351-Photoroom.png?v=ddc88a719a372cc57fa4314903ee596a"
              alt="한국문화체육진흥원 로고"
              className="h-8 md:h-9 w-auto object-contain"
            />
            <div className="flex flex-col">
              <span
                className={`text-sm md:text-base font-bold leading-tight transition-colors ${
                  scrolled ? 'text-navy-900' : 'text-white'
                }`}
              >
                한국문화체육진흥원
              </span>
              <span
                className={`text-[10px] md:text-xs leading-tight transition-colors ${
                  scrolled ? 'text-navy-500' : 'text-white/80'
                }`}
              >
                KCSPI
              </span>
            </div>
          </a>

          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`text-sm font-medium transition-colors hover:text-sky-500 whitespace-nowrap ${
                  scrolled ? 'text-navy-700' : 'text-white/90'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="메뉴"
          >
            <i
              className={`text-2xl ${
                scrolled ? 'text-navy-900' : 'text-white'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            />
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-navy-100 px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="block text-sm font-medium text-navy-700 hover:text-sky-500 py-2"
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}